import { Routes } from '@angular/router';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { PosComponent } from './components/pos/pos.component';
import { ReservationManagementComponent } from './components/reservation-management/reservation-management.component';
import { SalesInquiryComponent } from './components/sales-inquiry/sales-inquiry.component';
import { MembershipManagementComponent } from './components/membership-management/membership-management.component';
import { SettingsComponent } from './components/settings/settings.component';
import { ServiceSettingsComponent } from './components/service-settings/service-settings.component';
import { LanguageSettingsComponent } from './components/language-settings/language-settings.component';
import { CancellationManagementComponent } from './components/cancellation-management/cancellation-management.component';
import { ProfileComponent } from './components/profile/profile.component';
import {ForgotPass} from './components/forgot-pass/forgot-pass'

export const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: 'dashboard', component: DashboardComponent, data: { titleKey: 'SYSMENUS0006' } },
  { path: 'pos', component: PosComponent, data: { titleKey: 'SYSMENUS0014' } },
  { path: 'reservation', component: ReservationManagementComponent, data: { titleKey: 'SYSMENUS0009' } },
  { path: 'sales-inquiry', component: SalesInquiryComponent, data: { titleKey: 'SYSMENUS0010' } },
  { path: 'membership', component: MembershipManagementComponent, data: { titleKey: 'SYSMENUS0008' } },
  // { path: 'cancellation', component: CancellationManagementComponent, data: { titleKey: 'sidebar.cancellation' } },
  // { path: 'profile', component: ProfileComponent, data: { titleKey: 'profile.title' } },
  { path: 'settings', redirectTo: 'settings/store/env', pathMatch: 'full' },
  { path: 'settings/store/:tab', component: SettingsComponent, data: { titleKey: 'SYSMENUS0011' } },
  { path: 'settings/service', component: ServiceSettingsComponent, data: { titleKey: 'SYSMENUS0012' } },
  { path: 'settings/language', component: LanguageSettingsComponent, data: { titleKey: 'sidebar.languageSettings' } },
];
